"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAssetsList = void 0;
exports.findAssetListItem = findAssetListItem;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _semver = _interopRequireDefault(require("semver"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function findAssetListItem(asset, assetList) {
  return assetList.find(currentItem => currentItem.groupId === asset.groupId && currentItem.assetId === asset.assetId);
}
const buildAssetsList = ({
  results,
  asset,
  highlight,
  batchNumber
}) => {
  const existingAsset = results.find(currentItem => currentItem.asset.groupId === asset.groupId && currentItem.asset.assetId === asset.assetId);
  const newItem = {
    asset,
    highlight,
    replacedOutsideBatch: false,
    score: asset.score,
    batchNumber
  };

  // if GA was not fetched previously, add the new item
  if (!existingAsset) {
    return results.concat(newItem);
  }
  return results.map(currentItem => {
    if (currentItem.asset.assetId === newItem.asset.assetId && currentItem.asset.groupId === newItem.asset.groupId) {
      // if GA exists, separate the newer version from the oldest one
      const [selectedItem, discardedItem] = [newItem, currentItem].sort((a, b) => _semver.default.rcompare(a.asset.version, b.asset.version));
      const discardedItemScores = discardedItem.highlight.scores;
      const selectedItemScores = selectedItem.highlight.scores;
      const itemHighlight = _objectSpread(_objectSpread({}, selectedItem.highlight), {}, {
        scores: _objectSpread(_objectSpread({}, selectedItemScores), {}, {
          count: discardedItemScores.count + selectedItemScores.count,
          versions: _objectSpread(_objectSpread({}, discardedItemScores.versions), selectedItemScores.versions)
        })
      });

      // return highlight and scores data for the newest item
      const item = _objectSpread(_objectSpread({}, selectedItem), {}, {
        replacedOutsideBatch: currentItem.replacedOutsideBatch || selectedItem.batchNumber !== currentItem.batchNumber,
        highlight: itemHighlight
      });
      return item;
    }
    return currentItem;
  });
};
exports.buildAssetsList = buildAssetsList;
//# sourceMappingURL=list.js.map